import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DashBoard } from "./DataPad/DashBoard";
import { VerseGuide } from "./DataPad/VerseGuide";
import { Profile } from "./DataPad/Profile";
import {Layout} from "./Layout";
import {ListOfEmails} from "./DataPad/ListOfEmails";
import {QRCode} from "./DataPad/QRCode";
import {VerseGuideSystem} from "./DataPad/VerseGuideSystem";
import {EMail} from "./DataPad/EMail";
import {Squad} from "./DataPad/Squad";
import {Friends} from "./DataPad/Friends";
import {Ships} from "./DataPad/Ships";
import {IndustrialJobs} from "./DataPad/IndustrialJobs";
import {IndustrialLocations} from "./DataPad/IndustrialLocations";
import {IndustrialCreateJob} from "./DataPad/IndustrialCreateJob";
import {IndustrialMyJobs} from "./DataPad/IndustrialMyJobs";

export const Routing = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={ <Layout /> } >
					<Route path="" element={<DashBoard />} />
					<Route path="verse-guide" element={<VerseGuide />} />
					<Route path="verse-guide/:systemID" element={<VerseGuideSystem />} />
					<Route path="verse-guide/:systemID/:objectID" element={<VerseGuideSystem />} />
					<Route path="ships" element={<Ships />} />
					<Route path="ships/all" element={<Ships filter={'all'} /> } />
					<Route path="ships/mine" element={<Ships filter={'mine'} />} />
					<Route path="industrial-jobs" element={<IndustrialJobs />} />
					<Route path="industrial-jobs/create" element={<IndustrialCreateJob />} />
					<Route path="industrial-jobs/locations" element={<IndustrialLocations />} />
					<Route path="industrial-jobs/my-jobs" element={<IndustrialMyJobs />} />
					<Route path="profile" element={<Profile />} />
					<Route path="friends" element={<Friends />} />
					<Route path="mail" element={<ListOfEmails />} />
					<Route path="mail/:emailID" element={<EMail />} />
					<Route path="squad" element={<Squad />} />
					<Route path="share" element={<QRCode />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
};